<template>
    <div :style="height !== null ? `height:${height}px` : null" class="fill-height d-flex flex-column">
        <!--Header Slot-->
        <div>
            <slot name="header"></slot>
        </div>
        <!--Filter Bar-->
        <div v-if="multiple || showFilter" :class="dark ? 'primary' : null">
            <v-row
                    align="center"
                    no-gutters
                    style="flex-wrap: nowrap;"
            >
                <!--Select / Deselect Button-->
                <v-col
                        v-if="selectAll !== null"
                        class="flex-grow-0 flex-shrink-1 pl-2"
                >
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                    v-on="on"
                                    :color="dark ? 'white' : (selectAll ? 'grey' : 'primary')"
                                    style="cursor: pointer"
                                    @click="selectAll = !selectAll"
                            >
                                {{ selectAll ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked' }}
                            </v-icon>
                        </template>
                        <span>{{ selectAll ? 'Select All Items' : 'Clear Selection' }}</span>
                    </v-tooltip>
                </v-col>
                <!--Filter Text Field-->
                <v-col
                        v-if="showFilter"
                        class="flex-grow-1 flex-shrink-0 px-2 py-1"
                >
                    <v-text-field
                            ref="myField"
                            v-model="searchStr"
                            :color="dark ? 'white' : 'primary'"
                            :dark="dark"
                            :label="filterLabel"
                            class="pt-0 mt-0"
                            clearable
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            single-line
                    ></v-text-field>
                </v-col>
                <v-col
                        v-if="!showFilter && multiple"
                        class="flex-grow-1 flex-shrink-0 px-2 py-2 grey--text"
                >
                    {{ selectAll ? 'Select All Items' : 'Clear Selection' }}
                </v-col>
            </v-row>
        </div>
        <!--After Filter Slot-->
        <div>
            <slot name="afterFilter"></slot>
        </div>
        <!--        <v-divider></v-divider>-->

        <v-virtual-scroll
                :items="displayItems"
                :item-height="subLineKey || hasSubLine ? 38 : 26"
                class="fill-height"
                ref="vScroll"
        >
            <template v-slot:default="{ item }">
                <multi-select-list-item
                        :key="item[itemKey]"
                        :action-buttons="showActionButtons ? actionButtons : null"
                        :item="item"
                        :line1="headlineKey"
                        :line2="subLineKey"
                        :loading="loading ? loadingItems.includes(item) : false"
                        :selected="selectedItems.includes(item)"
                        :showCheckBoxes="showCheckBoxes"
                        @select="selectItem(item)"
                        @selection="selectionItem(item, $event)"
                >
                    <template slot="headline">
                        <slot
                                name="headline"
                                :value="item"
                                :selected="selectedItems.includes(item)"
                        />
                    </template>
                    <template slot="subLine">
                        <slot
                                name="subLine"
                                :value="item"
                                :selected="selectedItems.includes(item)"
                        />
                    </template>
                    <template slot="action">
                        <slot
                                name="action"
                                :value="item"
                                :selected="selectedItems.includes(item)"
                        />
                    </template>
                </multi-select-list-item>
            </template>
        </v-virtual-scroll>

        <!--        <div class="flex-grow-1 of-y">-->
        <!--            <template v-for="(item, i) in displayItems">-->

        <!--                <multi-select-list-item-->
        <!--                    :key="item[itemKey]"-->
        <!--                    :action-buttons="showActionButtons ? actionButtons : null"-->
        <!--                    :item="item"-->
        <!--                    :line1="headlineKey"-->
        <!--                    :line2="subLineKey"-->
        <!--                    :loading="loading ? loadingItems.includes(item) : false"-->
        <!--                    :selected="selectedItems.includes(item)"-->
        <!--                    :showCheckBoxes="showCheckBoxes"-->
        <!--                    @select="selectItem(item)"-->
        <!--                    @selection="selectionItem(item, $event)"-->
        <!--                >-->
        <!--                    <template slot="headline">-->
        <!--                        <slot-->
        <!--                                name="headline"-->
        <!--                                :value="item"-->
        <!--                                :index="i"-->
        <!--                                :selected="selectedItems.includes(item)"-->
        <!--                        />-->
        <!--                    </template>-->
        <!--                    <template slot="subLine">-->
        <!--                        <slot-->
        <!--                                name="subLine"-->
        <!--                                :value="item"-->
        <!--                                :index="i"-->
        <!--                                :selected="selectedItems.includes(item)"-->
        <!--                        />-->
        <!--                    </template>-->
        <!--                    <template slot="action">-->
        <!--                        <slot-->
        <!--                                name="action"-->
        <!--                                :value="item"-->
        <!--                                :index="i"-->
        <!--                                :selected="selectedItems.includes(item)"-->
        <!--                        />-->
        <!--                    </template>-->
        <!--                </multi-select-list-item>-->

        <!--            </template>-->
        <!--        </div>-->
        <!--Footer Slot-->
        <div>
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
import {arrPopulated, blankString} from "@/core/codeFunctions";
import MultiSelectListItem from "./MultiSelectListItem";

export default {
    components: {MultiSelectListItem},
    props: {
        items: Array,
        itemKey: {default: null, type: String},
        returnObject: {default: false, type: Boolean},
        showCheckBoxes: {default: false, type: Boolean},
        multiple: {default: true, type: Boolean},
        loading: {default: null, type: [Array, Object, Number, String, Boolean]},

        headlineKey: String,
        subLineKey: String,

        showActionButtons: {default: false, type: Boolean},
        actionButtons: Array,

        value: {default: null, type: [Array, Object, Number, String]},
        // {icon, color, cb, hoverItem}
        showFilter: {default: true, type: Boolean},

        filterLabel: {default: 'Filter Items', type: String},
        dark: {default: false, type: Boolean},
        height: {default: null, type: Number},

        customSortKey: {
            type: [String, Boolean],
            default: false
        },
        customFilter: Function,
    },
    data() {
        return {
            searchStr: null,
            console,
        }
    },
    methods: {
        clearFilter() {
            this.searchStr = null;
        },
        selectItem(item) {
            this.$emit('input', this.multiple ? [(this.returnObject ? item : item[this.itemKey])] : (this.returnObject ? item : item[this.itemKey]));
            this.$emit('selected', this.returnObject ? item : item[this.itemKey]);
        },
        selectionItem(item, add) {
            let vm = this;

            function input(val) {
                vm.$emit('input', val);
                vm.$emit('selected', add ? vm.returnObject ? item : item[vm.itemKey] : null);
            }

            if (this.multiple) {
                if (arrPopulated(this.value)) {
                    input(add
                            ? (
                                    this.returnObject
                                            ? this.value.concat([item])
                                            : this.value.concat([item[this.itemKey]])
                            )
                            : (
                                    this.returnObject
                                            ? this.value.filter(obj => obj !== item)
                                            : this.value.filter(obj => obj !== item[this.itemKey])
                            )
                    )
                } else {
                    input(add
                            ? (
                                    this.returnObject
                                            ? [item]
                                            : [item[this.itemKey]]
                            )
                            : null
                    )
                }
            } else {
                return add
                        ? input(this.returnObject ? item : item[this.itemKey])
                        : input(null)
            }
        }
    },
    computed: {
        hasHeadline() {
            return !!this.$slots.headline
        },
        hasSubLine() {
            return !!this.$slots.subLine
        },

        displayItems() {
                return this.items
                        .filter(obj => !this.customFilter ? (
                                blankString(this.searchStr)
                                        ? true
                                        : !blankString(obj[this.headlineKey])
                                                ? (JSON.stringify(obj).toLowerCase().includes(this.searchStr.toLowerCase()))
                                                : false
                                )
                                : this.customFilter(this.searchStr, obj)
                        )
                        .sort((a, b) => (!blankString(a[this.customSortKey || this.headlineKey]) ? a[this.customSortKey || this.headlineKey] : '') < (!blankString(b[this.customSortKey || this.headlineKey]) ? b[this.customSortKey || this.headlineKey] : '') ? -1 : 1);
        },

        selectAll: {
            get() {
                if (!this.multiple) {
                    return null
                } else {
                    return !arrPopulated(this.value)
                }
            },
            set(val) {
                let emitValues = val
                        ? []
                        : (
                                this.returnObject
                                        ? this.displayItems
                                        : this.displayItems.map(obj => {
                                            return obj[this.itemKey]
                                        })
                        )
                this.$emit('input', emitValues)
                this.$emit('selected',
                        emitValues.length === 0
                                ? null
                                : emitValues[0]
                );
            }
        },

        selectedItems() {
            if (this.multiple) {
                if (arrPopulated(this.value)) {
                    return this.returnObject
                            ? this.value
                            : this.items.filter(obj => this.value.includes(obj[this.itemKey]))
                } else {
                    return []
                }
            } else {
                try {
                    return this.returnObject
                            ? [this.value]
                            : this.items.filter(obj => obj[this.itemKey] === this.value)
                } catch (e) {
                    return null
                }
            }
        },
        loadingItems() {
            if (this.loading === true) {
                return this.items
            } else {
                if (this.multiple) {
                    if (arrPopulated(this.loading)) {
                        return this.returnObject
                                ? this.loading
                                : this.items.filter(obj => this.loading.includes(obj[this.itemKey]))
                    } else {
                        return []
                    }
                } else {
                    try {
                        return this.returnObject
                                ? [this.loading]
                                : this.items.filter(obj => obj[this.itemKey] === this.loading)
                    } catch (e) {
                        return null
                    }
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
